export enum GetGroupsFilter {
    All = 0,
    UsersOnly = 1,
    IssuersOnly = 2,
    SuperintendentsOnly = 3,
}
